import en from './locales/en';
import de from './locales/de';

export default {
  en,
  de,
};
